<template>
  <div class="report-box as-flex main-between cross-center">
    <div class="title as-flex main-center cross-center">{{reportInfo.name}}</div>
    <div class="as-flex main-center cross-center">
      <el-button @click="download" class="download-btn">
        下载报告
        <i class="el-icon-download el-icon--right"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportInfo: {}
  },
  data() {
    return {};
  },
  methods: {
    download() {
      window.open(this.reportInfo.link, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.report-box {
  border: 1px solid #efefef;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  padding: 0 10px;
  background-color: #ffffff;
  cursor: pointer;
  &:hover {
    border: 1px solid #22b1fd;
  }
  .title {
  }
  .download-btn {
    background-color: #22b1fd;
    color: #ffffff;
    &:hover {
      background-color: #47beff;
    }
  }
  .download-icon {
    font-size: 20px;
    &:hover {
      color: #22b1fd;
    }
  }
}
</style>
